var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fl-s-c",staticStyle:{"min-width":"1400px"}},[(_vm.html)?_c('div',{staticClass:"rich-text",domProps:{"innerHTML":_vm._s(_vm.html)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }